'use client';

import { useEffect } from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function RedirectSupport() {
  useDocumentTitle('Support');

  useEffect(() => {
    window.location.replace(
      'https://abri-support.atlassian.net/servicedesk/customer/portal/43',
    );
  }, []);

  return null;
}
